module.exports = __webpack_public_path__ + "static/media/puebla.7152b200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/puebla.png
// module id = 625
// module chunks = 0